<template>
  <validation-observer
    ref="form"
  >
    <b-row>
      <b-col md="6">
        <label>{{ getReplyTrans('image') }}</label>
        <div
          v-if="card.image_url && !img.length"
          class="image-container"
          :style="{backgroundImage:'url('+card.image_url+')'}"
        >
          <b-button
            class="remove-button btn-icon"
            variant="danger"
            size="sm"
            @click="card.image_url='',img=[]"
          >
            <FeatherIcon icon="TrashIcon" />
          </b-button>
        </div>
        <my-menu-media-input
          v-else
          v-model="img"
          :single="true"
          disable-video
          @uploaded="card.image_url=$event.med.url"
          @select-file="setCardImage($event)"
        />
      </b-col>
      <b-col md="6">
        <ok-text-input
          v-model="card.title"
          :label="getReplyTrans('card-title')"
          :placeholder="getReplyTrans('card-title-hint')"
          is-required
          rules="max:80"
        >
          <template #footer>
            <p class="mb-0 float-right">
              {{ titleLength +'/80' }}
            </p>
          </template>
        </ok-text-input>
        <ok-text-input
          v-model="card.subtitle"
          :label="getReplyTrans('card-subtitle')"
          :placeholder="getReplyTrans('card-subtitle-hint')"
          rules="max:80"
        >
          <template
            #footer
          >
            <p class="mb-0 float-right">
              {{ subTitleLength +'/80' }}
            </p>
          </template>
        </ok-text-input>
      </b-col>

      <b-col md="12">
        <buttons-input
          v-model="card.buttons"
          :show-remove-icon="true"
          :component-buttons="card.buttons"
        />
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import { BRow, BCol, BButton } from 'bootstrap-vue'
import ButtonsInput from '@/@bya3/components/inputs/ButtonsInput'
import { ValidationObserver } from 'vee-validate'
import MyMenuMediaInput from '@/views/media/MyMenuMediaInput'

export default {
  name: 'ReplyCardInput',
  components: {
    MyMenuMediaInput,
    ButtonsInput,
    OkTextInput,
    BRow,
    BCol,
    ValidationObserver,
    BButton,
  },
  props: {
    componentCard: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      card: {},
      img: [],
    }
  },
  computed: {
    titleLength() {
      return this.card?.title?.length ?? 0
    },
    subTitleLength() {
      return this.card?.subtitle?.length ?? 0
    },
  },
  watch: {
    card: {
      deep: true,
      handler() {
        this.$emit('input', this.card)
      },
    },
  },
  async mounted() {
    await (this.card = this.componentCard)
  },
  methods: {
    getReplyTrans(string) {
      return this.$t(`reply.form.${string}`)
    },
    setCardImage(files) {
      this.card.image_url = files[0]?.url ?? ''
    },
  },
}
</script>
